export function constructFullPath(baseUrl: string, path: string) {
  return path.startsWith('http') ? path : baseUrl + path;
}
